import React, { useState } from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';

export const THEME_MODES = [
  { id: 'day',   label: 'Day',   Icon: Sun },
  { id: 'night', label: 'Night', Icon: Moon },
  { id: 'auto',  label: 'Auto',  Icon: Monitor },
];

/* compact=true → tight icon-only buttons (nav bars)
   compact=false → pill buttons with labels (landing page) */
export default function ThemeSwitcher({ currentTheme, onThemeChange, compact = false, darkNav = false }) {
  const [hovered, setHovered] = useState(null);
  const mode = currentTheme || 'night';

  if (compact) {
    return (
      <div
        title="Theme"
        style={{ display: 'flex', alignItems: 'center', gap: 4 }}
      >
        {THEME_MODES.map(({ id, label, Icon }) => {
          const active = mode === id;
          const isHovered = hovered === id;
          return (
            <button
              key={id}
              onClick={() => onThemeChange(id)}
              onMouseEnter={() => setHovered(id)}
              onMouseLeave={() => setHovered(null)}
              title={label}
              aria-label={`${label} theme`}
              style={{
                width: 30,
                height: 30,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 8,
                background: active
                  ? 'var(--accent-light)'
                  : isHovered
                    ? 'rgba(127,127,127,0.12)'
                    : 'transparent',
                border: active
                  ? '1.5px solid var(--accent)'
                  : '1.5px solid transparent',
                color: active ? 'var(--accent)' : 'var(--text-secondary)',
                cursor: 'pointer',
                transition: 'all 0.18s ease',
                padding: 0,
              }}
            >
              <Icon size={16} strokeWidth={2.2} />
            </button>
          );
        })}
      </div>
    );
  }

  /* Full pill version */
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        background: darkNav ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
        backdropFilter: 'blur(12px)',
        borderRadius: 40,
        padding: '5px 6px',
      }}
    >
      {THEME_MODES.map(({ id, label, Icon }) => {
        const active = mode === id;
        return (
          <button
            key={id}
            onClick={() => onThemeChange(id)}
            title={label}
            aria-label={`${label} theme`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              padding: '6px 12px',
              borderRadius: 30,
              background: active ? (darkNav ? 'rgba(255,255,255,0.95)' : '#1A1A1A') : 'transparent',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              color: active
                ? (darkNav ? '#1A1A1A' : '#FFFFFF')
                : (darkNav ? 'rgba(255,255,255,0.80)' : 'rgba(0,0,0,0.70)'),
              fontFamily: 'inherit',
              boxShadow: active ? '0 1px 6px rgba(0,0,0,0.15)' : 'none',
            }}
          >
            <Icon size={14} strokeWidth={2.2} />
            <span style={{ fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap', letterSpacing: '0.02em' }}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
